<template>
  <section class="ead-page">    
    <b-message v-if="erro" type="is-danger" aria-close-label="Fechar" @close="erro = ''">
      {{ erro }}
    </b-message>

    <div class="box liberacoes-header">
      <div class="liberacoes-header__conteudo">
        <span class="liberacoes-header__icone">
          <b-icon icon="account-key-outline" />
        </span>
        <div>
          <p class="liberacoes-header__legenda">Gestão de acesso</p>
          <h1 class="title is-4 mb-1">Liberações de cursos</h1>
          <p class="has-text-grey">
          </p>
        </div>
      </div>
    </div>

    <div class="box liberacao-card">
      <div class="secao-titulo">
        <div class="secao-titulo__conteudo">
          <b-icon icon="account-plus-outline" type="is-primary" />
          <div>
            <h2 class="title is-5 mb-1">
              {{
                isInRole('rh-diretoria')
                  ? 'Nova liberação'
                  : 'Selecionar curso'
              }}
            </h2>
            <p class="has-text-grey is-size-7">
              {{
                isInRole('rh-diretoria')
                  ? 'Escolha o curso, o prazo e um ou mais funcionários.'
                  : 'Escolha um curso para consultar os acessos.'
              }}
            </p>
          </div>
        </div>
        <b-tag
          v-if="selecionados.length"
          rounded
          type="is-primary is-light"
        >
          {{ selecionados.length }}
          {{ selecionados.length === 1 ? 'selecionado' : 'selecionados' }}
        </b-tag>
      </div>

      <div
        class="liberacao-form"
        :class="{
          'liberacao-form--consulta': !isInRole('rh-diretoria'),
        }"
      >
        <b-field label="Curso">
          <b-select
            v-model="cursoId"
            expanded
            :loading="carregandoCursos"
            @input="carregarLiberacoes"
          >
            <option :value="null" disabled>Selecione um curso</option>
            <option v-for="c in cursos" :key="c.id" :value="c.id">
              {{ c.nome }}
            </option>
          </b-select>
        </b-field>

        <template v-if="isInRole('rh-diretoria')">
          <b-field label="Data limite" message="Opcional">
            <b-datepicker
              v-model="dataLimite"
              expanded
              icon="calendar"
              placeholder="Sem prazo"
              trap-focus
            />
          </b-field>

          <b-field
            label="Funcionários"
            message="Digite ao menos 2 caracteres"
          >
            <b-autocomplete
              v-model="busca"
              expanded
              :data="funcionariosDisponiveis"
              :loading="carregandoFuncionarios"
              field="nome"
              icon="account-search-outline"
              placeholder="Buscar por nome"
              keep-first
              @typing="agendarBuscaFuncionarios"
              @select="adicionar"
            >
              <template v-slot="props">
                <div class="autocomplete-funcionario">
                  <span class="funcionario-avatar funcionario-avatar--pequeno">
                    {{ obterIniciais(props.option.nome) }}
                  </span>
                  <div>
                    <p>{{ props.option.nome }}</p>
                    <p v-if="props.option.email" class="has-text-grey is-size-7">
                      {{ props.option.email }}
                    </p>
                  </div>
                </div>
              </template>
              <template #empty>
                <span class="has-text-grey is-size-7">
                  Nenhum funcionário encontrado.
                </span>
              </template>
            </b-autocomplete>
          </b-field>

          <b-field label="Ação" class="liberacao-form__acao">
            <b-button
              expanded
              type="is-primary"
              icon-left="account-check-outline"
              :disabled="!cursoId || !selecionados.length"
              :loading="salvando"
              @click="liberar"
            >
              Liberar curso
            </b-button>
          </b-field>
        </template>
      </div>

      <div v-if="selecionados.length" class="selecionados-card">
        <div class="selecionados-card__cabecalho">
          <span class="has-text-weight-semibold is-size-7">
            Funcionários que receberão acesso
          </span>
          <button type="button" class="button-limpar" @click="limparSelecionados">
            Limpar seleção
          </button>
        </div>
        <div class="funcionarios-selecionados">
          <b-tag
            v-for="f in selecionados"
            :key="f.id"
            rounded
            closable
            type="is-primary is-light"
            @close="remover(f)"
          >
            {{ f.nome }}
          </b-tag>
        </div>
      </div>
    </div>

    <div class="box acessos-card">
      <div class="acessos-cabecalho">
        <div>
          <h2 class="title is-5 mb-1">Acessos do curso</h2>
          <p class="has-text-grey is-size-7">
            {{ cursoSelecionado ? cursoSelecionado.nome : 'Selecione um curso acima' }}
          </p>
        </div>
        <div v-if="cursoId" class="resumo-acessos">
          <span class="resumo-item">
            <strong>{{ resumo.total }}</strong> Total
          </span>
          <span class="resumo-item resumo-item--ativo">
            <strong>{{ resumo.ativos }}</strong> Com acesso
          </span>
          <span class="resumo-item resumo-item--atrasado">
            <strong>{{ resumo.atrasados }}</strong> Em atraso
          </span>
          <span class="resumo-item resumo-item--bloqueado">
            <strong>{{ resumo.bloqueados }}</strong> Bloqueados
          </span>
        </div>
      </div>

      <div v-if="!cursoId" class="estado-vazio">
        <span class="estado-vazio__icone">
          <b-icon icon="book-open-page-variant" size="is-medium" />
        </span>
        <p class="has-text-weight-semibold">Nenhum curso selecionado</p>
        <p class="has-text-grey is-size-7">
          Selecione um curso para visualizar os funcionários com acesso.
        </p>
      </div>

      <b-table
        v-else
        :data="liberacoes"
        :loading="carregandoLiberacoes"
        :mobile-cards="true"
        hoverable
        class="liberacoes-tabela"
      >
        <b-table-column label="Funcionário" field="funcionario" v-slot="p">
          <div class="funcionario-identificacao">
            <span class="funcionario-avatar">
              {{ obterIniciais(p.row.funcionario) }}
            </span>
            <div>
              <p class="has-text-weight-semibold">{{ p.row.funcionario }}</p>
              <p class="has-text-grey is-size-7">
                Liberado em {{ formatarData(p.row.dataLiberacao) }}
              </p>
            </div>
          </div>
        </b-table-column>

        <b-table-column label="Status" field="status" v-slot="p">
          <b-tag rounded :type="tipoStatus(p.row)">
            {{ textoStatus(p.row) }}
          </b-tag>
        </b-table-column>

        <b-table-column label="Prazo" field="dataLimite" v-slot="p">
          <span
            class="prazo-liberacao"
            :class="{ 'prazo-liberacao--atrasado': p.row.atrasado }"
          >
            <b-icon
              :icon="p.row.atrasado ? 'alert-circle-outline' : 'calendar-outline'"
              size="is-small"
            />
            {{ p.row.dataLimite ? formatarData(p.row.dataLimite) : 'Sem prazo' }}
          </span>
        </b-table-column>

        <b-table-column
          v-if="isInRole('rh-diretoria')"
          label="Ações"
          v-slot="p"
        >
          <div class="acoes-liberacao">
            <b-button
              size="is-small"
              :type="p.row.status === 'BLOQUEADO' ? 'is-success is-light' : 'is-light'"
              :icon-left="p.row.status === 'BLOQUEADO' ? 'lock-open-outline' : 'lock-outline'"
              :loading="alterandoId === p.row.id"
              :disabled="alterandoId !== null || excluindoId !== null"
              @click="confirmarAlteracaoAcesso(p.row)"
            >
              {{
                p.row.status === 'BLOQUEADO'
                  ? 'Restaurar acesso'
                  : 'Bloquear acesso'
              }}
            </b-button>
            <b-button
              size="is-small"
              type="is-danger is-light"
              icon-left="delete-outline"
              title="Excluir permanentemente"
              aria-label="Excluir permanentemente"
              :loading="excluindoId === p.row.id"
              :disabled="alterandoId !== null || excluindoId !== null"
              @click="confirmarExclusao(p.row)"
            />
          </div>
        </b-table-column>

        <template #empty>
          <div v-if="!carregandoLiberacoes" class="estado-vazio">
            <span class="estado-vazio__icone">
              <b-icon icon="account-off-outline" size="is-medium" />
            </span>
            <p class="has-text-weight-semibold">Nenhuma liberação encontrada</p>
            <p class="has-text-grey is-size-7">
              Este curso ainda não foi liberado para nenhum funcionário.
            </p>
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import http from '@/http'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'EadLiberacoes',
  data: () => ({
    cursos: [],
    cursoId: null,
    busca: '',
    funcionarios: [],
    selecionados: [],
    liberacoes: [],
    dataLimite: null,
    salvando: false,
    carregandoCursos: false,
    carregandoFuncionarios: false,
    carregandoLiberacoes: false,
    alterandoId: null,
    excluindoId: null,
    timerFuncionarios: null,
    erro: '',
  }),
  computed: {
    ...mapState(['unidadeId']),
    ...mapGetters(['isInRole']),
    cursoSelecionado() {
      return this.cursos.find((curso) => curso.id === this.cursoId) || null
    },
    funcionariosDisponiveis() {
      return this.funcionarios.filter(
        (funcionario) =>
          !this.selecionados.some((selecionado) => selecionado.id === funcionario.id)
      )
    },
    resumo() {
      return {
        total: this.liberacoes.length,
        ativos: this.liberacoes.filter((x) => x.status !== 'BLOQUEADO').length,
        atrasados: this.liberacoes.filter((x) => x.atrasado).length,
        bloqueados: this.liberacoes.filter((x) => x.status === 'BLOQUEADO').length,
      }
    },
  },
  watch: {
    unidadeId() {
      this.erro = ''
      this.cursoId = null
      this.liberacoes = []
      this.selecionados = []
      this.carregarCursos()
    },
  },
  mounted() {
    this.carregarCursos()
  },
  beforeDestroy() {
    clearTimeout(this.timerFuncionarios)
  },
  methods: {
    mostrarErro(erro, mensagemPadrao) {
      this.erro = (erro && erro.data && erro.data.erro) || mensagemPadrao
    },
    carregarCursos() {
      this.carregandoCursos = true
      this.erro = ''
      http
        .get('/api/search/ead-cursos', {
          params: { unidadeId: this.unidadeId },
        })
        .then((r) => {
          this.cursos = r.data.lista || []
        })
        .catch((erro) => {
          this.cursos = []
          this.mostrarErro(erro, 'Não foi possível carregar os cursos.')
        })
        .finally(() => (this.carregandoCursos = false))
    },
    agendarBuscaFuncionarios(nome) {
      clearTimeout(this.timerFuncionarios)
      if (!nome || nome.trim().length < 2) {
        this.funcionarios = []
        this.carregandoFuncionarios = false
        return
      }
      this.carregandoFuncionarios = true
      this.timerFuncionarios = setTimeout(
        () => this.buscarFuncionarios(nome.trim()),
        300
      )
    },
    buscarFuncionarios(nome) {
      this.erro = ''
      http
        .get('/api/search/ead-funcionarios', {
          params: { unidadeId: this.unidadeId, nome },
        })
        .then((r) => (this.funcionarios = r.data || []))
        .catch((erro) => {
          this.funcionarios = []
          this.mostrarErro(erro, 'Não foi possível buscar os funcionários.')
        })
        .finally(() => (this.carregandoFuncionarios = false))
    },
    adicionar(funcionario) {
      if (
        funcionario &&
        !this.selecionados.some((x) => x.id === funcionario.id)
      ) {
        this.selecionados.push(funcionario)
      }
      this.busca = ''
      this.funcionarios = []
    },
    remover(funcionario) {
      this.selecionados = this.selecionados.filter(
        (x) => x.id !== funcionario.id
      )
    },
    limparSelecionados() {
      this.selecionados = []
    },
    carregarLiberacoes() {
      this.erro = ''
      if (!this.cursoId) {
        this.liberacoes = []
        return
      }
      this.carregandoLiberacoes = true
      http
        .get('/api/ead-liberacoes', { params: { cursoId: this.cursoId } })
        .then((r) => (this.liberacoes = r.data || []))
        .catch((erro) => {
          this.liberacoes = []
          this.mostrarErro(erro, 'Não foi possível carregar os acessos do curso.')
        })
        .finally(() => (this.carregandoLiberacoes = false))
    },
    liberar() {
      this.salvando = true
      this.erro = ''
      http
        .post('/api/ead-liberacoes', {
          cursoId: this.cursoId,
          funcionarioIds: this.selecionados.map((x) => x.id),
          dataLimite: this.dataLimite,
        })
        .then(() => {
          this.selecionados = []
          this.$buefy.toast.open({
            message: 'Curso liberado.',
            type: 'is-success',
          })
          this.carregarLiberacoes()
        })
        .catch((erro) => {
          this.mostrarErro(erro, 'Não foi possível liberar o curso.')
        })
        .finally(() => (this.salvando = false))
    },
    confirmarAlteracaoAcesso(liberacao) {
      const bloqueado = liberacao.status === 'BLOQUEADO'
      this.$buefy.dialog.confirm({
        title: bloqueado ? 'Restaurar acesso' : 'Remover acesso',
        message: bloqueado
          ? `Deseja restaurar o acesso de ${liberacao.funcionario} ao curso?`
          : `Deseja remover o acesso de ${liberacao.funcionario} ao curso? O progresso será preservado.`,
        confirmText: bloqueado ? 'Restaurar' : 'Remover acesso',
        cancelText: 'Cancelar',
        type: bloqueado ? 'is-success' : 'is-danger',
        hasIcon: true,
        onConfirm: () => this.alterarAcesso(liberacao, !bloqueado),
      })
    },
    alterarAcesso(liberacao, bloqueado) {
      this.alterandoId = liberacao.id
      this.erro = ''
      http
        .put(`/api/ead-liberacoes/${liberacao.id}`, {
          dataLimite: liberacao.dataLimite,
          bloqueado,
        })
        .then(() => {
          this.$buefy.toast.open({
            message: bloqueado ? 'Acesso removido.' : 'Acesso restaurado.',
            type: 'is-success',
          })
          this.carregarLiberacoes()
        })
        .catch((erro) => {
          this.mostrarErro(erro, 'Não foi possível alterar o acesso.')
        })
        .finally(() => (this.alterandoId = null))
    },
    confirmarExclusao(liberacao) {
      this.$buefy.dialog.confirm({
        title: 'Excluir liberação permanentemente',
        message: `Deseja excluir definitivamente a liberação de ${liberacao.funcionario}? Todo o progresso, respostas, comentários, tentativas e certificado deste curso serão apagados.`,
        confirmText: 'Excluir definitivamente',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.excluirLiberacao(liberacao),
      })
    },
    excluirLiberacao(liberacao) {
      this.excluindoId = liberacao.id
      this.erro = ''
      http
        .delete(`/api/ead-liberacoes/${liberacao.id}`)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Liberação excluída.',
            type: 'is-success',
          })
          this.carregarLiberacoes()
        })
        .catch((erro) => {
          this.mostrarErro(erro, 'Não foi possível excluir a liberação.')
        })
        .finally(() => (this.excluindoId = null))
    },
    obterIniciais(nome) {
      if (!nome) return '?'
      const partes = nome.trim().split(/\s+/)
      return `${partes[0][0]}${partes.length > 1 ? partes[partes.length - 1][0] : ''}`.toUpperCase()
    },
    formatarData(valor) {
      if (!valor) return '—'
      return new Date(valor).toLocaleDateString('pt-BR')
    },
    textoStatus(liberacao) {
      if (liberacao.atrasado) return 'Em atraso'
      const textos = {
        NAO_INICIADO: 'Não iniciado',
        EM_ANDAMENTO: 'Em andamento',
        CONCLUIDO: 'Concluído',
        BLOQUEADO: 'Bloqueado',
      }
      return textos[liberacao.status] || liberacao.status
    },
    tipoStatus(liberacao) {
      if (liberacao.atrasado) return 'is-danger'
      const tipos = {
        NAO_INICIADO: 'is-light',
        EM_ANDAMENTO: 'is-info is-light',
        CONCLUIDO: 'is-success',
        BLOQUEADO: 'is-dark',
      }
      return tipos[liberacao.status] || 'is-light'
    },
  },
}
</script>

<style scoped>
.ead-page {
  min-height: 100%;
}

.liberacoes-header,
.liberacoes-header__conteudo,
.secao-titulo,
.secao-titulo__conteudo,
.selecionados-card__cabecalho,
.autocomplete-funcionario,
.acessos-cabecalho,
.resumo-acessos,
.funcionario-identificacao,
.prazo-liberacao,
.acoes-liberacao {
  align-items: center;
  display: flex;
}

.liberacoes-header {
  border-left: 4px solid #00b89c;
  margin-bottom: 1.25rem;
}

.liberacoes-header__conteudo,
.secao-titulo__conteudo {
  gap: 0.85rem;
}

.liberacoes-header__icone,
.estado-vazio__icone,
.funcionario-avatar {
  align-items: center;
  background: rgba(0, 184, 156, 0.11);
  color: #008f79;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
}

.liberacoes-header__icone {
  border-radius: 50%;
  height: 3rem;
  width: 3rem;
}

.liberacoes-header__legenda {
  color: #7a7a7a;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
}

.liberacao-card,
.acessos-card {
  border: 1px solid #ededed;
  box-shadow: 0 2px 8px rgba(10, 10, 10, 0.05);
}

.liberacao-card {
  margin-bottom: 1.25rem;
}

.secao-titulo,
.acessos-cabecalho {
  border-bottom: 1px solid #ededed;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
}

.liberacao-form {
  align-items: start;
  display: grid;
  gap: 0.75rem;
  grid-template-columns:
    minmax(220px, 2fr) minmax(180px, 1fr) minmax(260px, 2fr) auto;
}

.liberacao-form--consulta {
  grid-template-columns: minmax(260px, 480px);
}

.liberacao-form__acao {
  align-self: start;
}

.liberacao-form__acao .button {
  min-width: 160px;
}

.autocomplete-funcionario,
.funcionario-identificacao {
  gap: 0.65rem;
}

.funcionario-avatar {
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 700;
  height: 2.4rem;
  width: 2.4rem;
}

.funcionario-avatar--pequeno {
  height: 2rem;
  width: 2rem;
}

.selecionados-card {
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 7px;
  margin-top: 0.35rem;
  padding: 0.85rem;
}

.selecionados-card__cabecalho {
  justify-content: space-between;
  margin-bottom: 0.65rem;
}

.button-limpar {
  background: none;
  border: 0;
  color: #008f79;
  cursor: pointer;
  font-size: 0.75rem;
  padding: 0;
}

.funcionarios-selecionados,
.resumo-acessos {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.acessos-card {
  overflow: hidden;
  padding: 0;
}

.acessos-cabecalho {
  background: #fafafa;
  margin: 0;
  padding: 1rem 1.25rem;
}

.resumo-acessos {
  justify-content: flex-end;
}

.resumo-item {
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 999px;
  color: #7a7a7a;
  font-size: 0.75rem;
  padding: 0.35rem 0.65rem;
}

.resumo-item strong {
  color: #363636;
  margin-right: 0.2rem;
}

.resumo-item--ativo {
  border-color: rgba(0, 184, 156, 0.3);
}

.resumo-item--atrasado {
  border-color: rgba(241, 70, 104, 0.35);
}

.resumo-item--bloqueado {
  border-color: #b5b5b5;
}

.liberacoes-tabela {
  padding: 0.5rem 1rem 1rem;
}

.prazo-liberacao {
  color: #7a7a7a;
  gap: 0.35rem;
  white-space: nowrap;
}

.prazo-liberacao--atrasado {
  color: #f14668;
  font-weight: 600;
}

.acoes-liberacao {
  gap: 0.5rem;
  white-space: nowrap;
}

.estado-vazio {
  align-items: center;
  color: #7a7a7a;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
}

.estado-vazio__icone {
  border-radius: 50%;
  height: 3.5rem;
  margin-bottom: 0.75rem;
  width: 3.5rem;
}

@media screen and (max-width: 1100px) {
  .liberacao-form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 768px) {
  .liberacoes-header__conteudo,
  .secao-titulo,
  .acessos-cabecalho {
    align-items: flex-start;
    flex-direction: column;
  }

  .liberacao-form,
  .liberacao-form--consulta {
    grid-template-columns: 1fr;
  }

  .liberacao-form__acao .button {
    width: 100%;
  }

  .resumo-acessos {
    justify-content: flex-start;
  }

  .acoes-liberacao {
    flex-wrap: wrap;
  }
}
</style>
